export type LicensesCommandResult = {
  exitCode: number;
  output: string;
};
